import React, { useState } from 'react';

interface JsonModalProps {
  data: unknown;
}

function safeSerialize(data: unknown): string {
  try {
    return JSON.stringify(
      data,
      (_key, value) => {
        if (value instanceof ImageData)   return '[ImageData]';
        if (value instanceof ArrayBuffer) return '[ArrayBuffer]';
        if (ArrayBuffer.isView(value))    return '[TypedArray]';
        return value;
      },
      2,
    );
  } catch {
    return '"No se pudo serializar el resultado."';
  }
}

/** Modal para visualizar el resultado JSON completo del scan (modo debug/demo). */
export const JsonModal: React.FC<JsonModalProps> = ({ data }) => {
  const [open, setOpen] = useState(false);
  const json = safeSerialize(data);

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="btn-secondary w-full">
        Ver JSON completo
      </button>

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
          onClick={() => setOpen(false)}
        >
          <div
            className="relative flex max-h-[85vh] w-full max-w-2xl flex-col rounded-2xl bg-white shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between border-b px-6 py-4">
              <h4 className="font-semibold text-gray-800">Resultado JSON</h4>
              <button
                onClick={() => setOpen(false)}
                className="rounded-lg p-1 text-gray-400 hover:bg-gray-100"
                aria-label="Cerrar"
              >✕</button>
            </div>
            <div className="flex-1 overflow-y-auto px-6 py-4">
              <pre className="whitespace-pre-wrap break-all font-mono text-xs text-gray-600">{json}</pre>
            </div>
            <div className="flex justify-end border-t px-6 py-3">
              <button onClick={() => setOpen(false)} className="btn-primary px-5 py-2 text-sm">
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
